export default __webpack_public_path__ + "static/media/photo--lg--rob.a10f6ed5.jpg";